import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import Device from 'src/app/services/device.model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-auto-update',
  templateUrl: './auto-update.component.html',
  styleUrls: ['./auto-update.component.scss']
})
export class AutoUpdateComponent implements OnInit, OnDestroy {
  public devices: Array<Device> = [];
  public device: Device = new Device();
  public autoUpdateForm: FormGroup;
  public submitted = false;
  public enableDisablePageLoader: boolean = false;
  public submitting: boolean = false;

  constructor(
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    public deviceService: DeviceService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) {
    this.device = new Device();
    this.autoUpdateForm = this.formBuilder.group({
      serial_number: ['', Validators.required],
      fileName: ['', Validators.required],
    });
  }

  public async ngOnInit() {
    try {
      window.scrollTo(0, 0);
      this.enableDisablePageLoader = true;
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.devices = await this.deviceService.getAllDevices();
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  public ngOnDestroy(): void {
    this.deviceService.cancelOnGoingHttpRequests();
  }

  public get autoUpdateFormValidation() {
    return this.autoUpdateForm.controls;
  }

  public async autoUpdate() {
    this.submitted = true;
    if (this.autoUpdateForm.invalid) {
      return;
    }
    const formData = this.autoUpdateForm.value;
    this.device.serial_number = formData.serial_number;
    this.device.url = formData.fileName;

    try {
      this.submitting = true;
      const res = await this.deviceService.autoUpdate(this.device);
      if (res) {
        this.toastrService.success('Device code updated successfully', '', { timeOut: 2000 });
        this.device = new Device();
        this.submitted = false;
        this.autoUpdateForm.reset();
      }
      this.submitting = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.submitting = false;
    }
  }
}

